<template>
  <div class="p-4 bg-white rounded-lg shadow-md">
    <h1 class="text-2xl font-bold mb-4">Template From Example</h1>
    <p class="text-sm mb-4">
      You can create a template by providing an example contract. The contract will be analyzed and the template will be generated based on
      the contract. The AI will try to extract all sections and template variables.
    </p>
    <p class="text-sm mb-4"><strong>Here are some tips for better results:</strong></p>
    <ul class="list-disc text-sm list-inside mb-4 w-1/2">
      <li>
        Avoid using PDFs with scanned text. They are hard to read for our AI. As a rule of thumb, if you cannot select text with your mouse,
        in the document, it's hard to read for our AI.
      </li>
      <li>Make sure the document is not password protected.</li>
      <li>Upload a version of the document that only contains the text and no images or tables</li>
    </ul>
    <FormKit type="form" @submit="handleSubmit">
      <FormKit type="text" name="name" validation="required" label="Template Name"></FormKit>
      <FormKit type="file" name="file" validation="required" label="Example Contract"></FormKit>
    </FormKit>
  </div>
</template>

<script lang="ts" setup>
import { createTemplateFromExampleContract } from '@/admin/services/template-service'
import type { FormKitFile } from '@formkit/inputs'
import router from '../questionnaireRouter'
import type { FormKitNode } from '@formkit/core'
import { useMutation } from '@tanstack/vue-query'

type ExampleUploadFormdata = {
  name: string
  file: FormKitFile[]
}

const { mutateAsync } = useMutation({
  mutationFn: (data: ExampleUploadFormdata) => createTemplateFromExampleContract(data.name, data.file[0].file!),
  onSuccess: result => {
    router.push({ name: 'checkAiRun', params: { id: result.id } })
  },
})

const handleSubmit = async (formData: ExampleUploadFormdata, node: FormKitNode) => {
  await mutateAsync(formData).catch(error => {
    node.setErrors(error.response?.data.errors)
  })
}
</script>
